/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import { makeAlertReducers, makeAlertSelectors } from 'ui-lottery/src/reducers/alerts';
import { PREFIX } from '../constants/actions';

export const { alerts } = makeAlertReducers(PREFIX);
export const selectors = makeAlertSelectors('pass');
